import React, { Component } from 'react';
import { Row, Col } from 'react-materialize';
import { Card, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { HOSTNAME } from '../config.js';
import { getTitleRetention } from './constants';
import '../css/landing.css';

export class LandingCards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      barriers: '',
      group: '',
      countCards: 6
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    fetch(HOSTNAME + 'api.php/barrier?transform=1&include=barrier_image,barrier_stat')
    .then(response => response.json())
    .then(parsedJson => parsedJson.barrier.map(barriers => (
      {
        id: `${barriers.id}`,
        group_id: `${barriers.group_id}`,
        stand_id: `${barriers.stand_id}`,
        impact_energy: `${barriers.impact_energy}`,
        height: `${barriers.height}`,
        stand_step: `${barriers.stand_step}`,
        dynamic_deflection: `${barriers.dynamic_deflection}`,
        stand_mark: `${barriers.stand_mark}`,
        image: `${barriers.barrier_image.map(item => item.filename)}`,
        stat: `${barriers.barrier_stat.map(item => item.count)}`,
        balk: `${barriers.balk_count}`,
        workingWidth: `${barriers.working_width}`,
        weight: `${barriers.weight}`,
        top_section: `${barriers.top_section}`,
        mid_section: `${barriers.mid_section}`,
        low_section: `${barriers.low_section}`,
        sketchfab_id: `${barriers.sketchfab_id}`,
      }
    )))
    .then(barriers => this.setState({barriers}))
    .catch(error => console.log('fetch data error', error));

    fetch(HOSTNAME + 'api.php/barrier_group?transform=1')
    .then(response => response.json())
    .then(parsedJson => parsedJson.barrier_group.map(group => (
      {
        id: `${group.id}`,
        name: `${group.name}`,
        shortname: `${group.shortname}`,
        sides: `${group.sides}`,
        type: `${group.type}`,
        base: `${group.base}`
      }
    )))
    .then(group => this.setState({group}))
    .catch(error => console.log('fetch group error', error));

    fetch(HOSTNAME + 'api.php/stand?transform=1')
    .then(response => response.json())
    .then(parsedJson => parsedJson.stand.map(stand => (
    {
      id: `${stand.id}`,
      mark: `${stand.mark}`,
      profile: `${stand.profile}`,
      length: `${stand.length}`
    }
    )))
    .then(stand => this.setState({stand}))
    .catch(error => console.log('fetch stand error', error));
  }

  render() {
    let randArray = [];
    let duplicate = false;
    let duplicatesId = [];
    let barriers = this.state.barriers;

    if (barriers.length > 0) {
      while (randArray.length !== this.state.countCards) {
        let randId = parseInt(Math.floor(Math.random() * barriers.length), 10);

        for (let j in randArray) {
          if (randId === duplicatesId[j]) {
            duplicate = true;
          }
        }

        if (duplicate === false) {
          randArray.push(barriers[randId]);
          duplicatesId.push(randId);
        } else {
          duplicate = false;
        }
      }
    }

    return(
      <div className='container'>
        <Row className='cards'>
          {
            randArray.length > 0 ? randArray.slice().map(randArray => {
              let { id, impact_energy, height, stand_step, dynamic_deflection, stat, group_id, stand_id, workingWidth } = randArray;
              let image = randArray.image.split(',');

              image = image[0];

              if (image === '') {
                image = 'no-image-min.jpg';
              }

              let stat_title = getTitleRetention(stat);

              let bg_shortname = '';
              for (let i in this.state.group) {
                if (this.state.group[i].id === group_id) {
                  bg_shortname = this.state.group[i].shortname;
                }
              }

              let stand_mark = '';
              for (let i in this.state.stand) {
                if (this.state.stand[i].id === stand_id) {
                  stand_mark = this.state.stand[i].mark;
                }
              }

              return (
                <Col s={12} m={6} l={4} key={id}>
                  <Card>
                    <Image src={`${HOSTNAME}img/barrier_image/${image}`} rel={id} alt={id}/>
                    <Card.Content>
                      <Card.Header>
                        {bg_shortname} / {impact_energy} - {height} - {stand_step} ÷ {dynamic_deflection} ({workingWidth}) {stat_title} ({stand_mark}) #{id}
                      </Card.Header>
                      <Card.Description>
                          <Link to={`/types/${id}`} className='btn waves-effect waves-light btn-field'>Подробнее</Link>
                      </Card.Description>
                    </Card.Content>
                  </Card>
                </Col>
              )
            }) : null
          }
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landingCards.js